import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Form } from 'antd';

import { PickDtoFilter } from '@/shared/lib/forms/form-wrapper.types';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { Table, TableProps } from '@/shared/uikitV2/Table';

import { AllowedCollectionsSelectDataNames, SelectOptions } from './types';
import { useSelectData } from './useSelectData';

type SelectItemProps = {
  formId: string;
  colName: AllowedCollectionsSelectDataNames;
  multiple?: boolean;
  values?: DtoId[];
  excludeIds?: DtoId[];
  onSelect: (options: SelectOptions) => void;
  filter?: PickDtoFilter;
};

export const SelectItem = ({
  formId,
  colName,
  multiple,
  values = [],
  excludeIds,
  onSelect,
  filter,
}: SelectItemProps) => {
  const [selected, setSelected] = useState<DtoId[]>(values);
  const { handleSubmit: formHandleSubmit } = useForm();

  const { items, columns } = useSelectData({ colName, excludeIds, filter });
  type Row = (typeof items)[number];

  const rowSelection: TableProps<Row>['rowSelection'] = {
    type: multiple ? 'checkbox' : 'radio',
    selectedRowKeys: selected,
    onChange: (_selectedRowKeys) => {
      setSelected(_selectedRowKeys.map((key) => key.toString()));
    },
  };

  const handleItemClick = (item: Row) => {
    if (multiple) {
      setSelected((prevSelected) =>
        prevSelected.includes(item.id)
          ? prevSelected.filter((selection) => selection !== item.id)
          : [...prevSelected, item.id],
      );
      return;
    }

    setSelected([item.id]);
  };

  const handleSubmit = () => {
    onSelect({ colName, id: multiple ? selected : selected[0] });
  };

  return (
    <Form id={formId} onFinish={formHandleSubmit(handleSubmit)}>
      <Table<Row>
        items={items}
        columns={columns}
        rowSelection={rowSelection}
        onClickItem={handleItemClick}
      />
    </Form>
  );
};
